/**
 * UK GDPR and PECR compliant cookie consent translations
 * Based on Coventry University pattern and ICO guidelines
 */

export const cookieConsentTranslations = {
    // Main consent banner/popup
    title: 'Cookie consent',
    message:
        "We use necessary cookies to make our site work. We'd like to set additional cookies to understand site usage, make site improvements and to remember your settings. We also use cookies set by other sites to help deliver content from their services.",
    buttonText: 'Accept additional cookies',
    declineButtonText: 'Reject additional cookies',
    manageButtonText: 'Manage my choices',
    privacyPolicyText: 'View our privacy policy',

    // Manage consent modal
    manageTitle: 'Cookie Preferences',
    manageMessage:
        'Manage your cookie preferences below. Essential cookies are always enabled as they are necessary for the website to function properly.',

    // Essential cookies section (always on)
    manageEssentialTitle: 'Essential Cookies',
    manageEssentialSubtitle: 'Required for the website to function properly',
    manageEssentialStatus: 'Status: Always enabled',
    manageEssentialStatusButtonText: 'Always On',

    // Analytics cookies section
    manageAnalyticsTitle: 'Analytics Cookies',
    manageAnalyticsSubtitle: 'Help us understand how visitors interact with our website to improve your experience',

    // Social cookies section
    manageSocialTitle: 'Social Media Cookies',
    manageSocialSubtitle: 'Enable embedded content from Spotify and Google Maps. These services may set cookies to track your activity.',

    // Advertising cookies section (not currently used)
    manageAdvertTitle: 'Advertising Cookies',
    manageAdvertSubtitle: 'Personalize advertisements and measure their performance',

    // Status messages
    manageCookiesStatus: 'Status: {{status}} on {{date}}',
    manageCookiesStatusConsented: 'Consented',
    manageCookiesStatusDeclined: 'Declined',

    // Buttons in manage modal
    manageCancelButtonText: 'Cancel',
    manageSaveButtonText: 'Save Preferences',
} as const

export type CookieConsentTranslations = typeof cookieConsentTranslations
